// The working day, as the grids draw it: 08:00 to midnight on the half hour.
//
// THESE NUMBERS ARE THE SERVER'S (server/constants/calendar.js). The client cannot import
// them, so they are restated here — but nothing about free/busy is decided with them. The
// server computes which slots are offerable and sends back the grid; these constants only
// say how tall to draw the day and which hour lines to label. A disagreement would make
// the picture wrong, never the booking.
export const WORK_START = 8 * 60;   // 08:00
export const WORK_END = 24 * 60;    // 24:00
export const SLOT_MINUTES = 30;

export const DAY_MINUTES = WORK_END - WORK_START;

// The hour lines down the side of the day and week grids: 08:00 … 23:00, plus the closing
// 24:00 label at the very bottom.
export const HOUR_MARKS = (() => {
  const marks = [];
  for (let m = WORK_START; m <= WORK_END; m += 60) marks.push(m);
  return marks;
})();

export const asTime = (minutes) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

// Where a meeting sits in the day column, as percentages — so the grid scales with
// whatever height the CSS gives it and no pixel arithmetic leaks into the components.
export const placeInDay = (startMinutes, endMinutes) => ({
  top: `${((startMinutes - WORK_START) / DAY_MINUTES) * 100}%`,
  height: `${((endMinutes - startMinutes) / DAY_MINUTES) * 100}%`,
});
